import { createContext, useState, useCallback, useMemo } from 'react';

export const ModalContext = createContext({
  modalsVisibility: null,
  setModalsVisibility: () => {},
  modalData: {},
  setModalData: () => {},
  openModal: () => {},
  closeModal: () => {},
});

export const MODAL_CONTEXTS = {
  IW_BALANCE_AND_AGE : 'balanceAndAge',
  IW_CANCEL_DRAWDOWN: 'cancelDrawdown',
  IW_ELECTION_ERROR : 'electionError',
  IW_SOCIAL_SECURITY : 'socialSecurityBenefit',
  IW_TERMS_AND_CONDITIONS : 'termsAndConditions',
  EXAMPLE_CAROUSEL : 'carousel',
  SRLI_CONFIRMATION : 'jpmConfirmation',
  SRLI_DIALOG : 'srliDialog',
};

export function ModalContextProvider({ children }) {
  const [modalsVisibility, setModalsVisibility] = useState({
    balanceAndAge: false,
    [MODAL_CONTEXTS.IW_CANCEL_DRAWDOWN]: false,
    [MODAL_CONTEXTS.IW_ELECTION_ERROR]: false,
    carousel: false,
    socialSecurityBenefit: false,
    jpmConfirmation: false,
    srliDialog: false,
    termsAndConditions: false,
    importantInfo: false,
  });

  const [modalData, setModalData] = useState({});

  const openModal = useCallback((key) => {
    setModalsVisibility(prevState => ({
      ...prevState,
      [key]: true,
    }));
  }, []);

  const closeModal = useCallback((key) => {
    setModalsVisibility(prevState => ({
      ...prevState,
      [key]: false,
    }));
  }, []);

  const value = useMemo(() => ({
    modalsVisibility,
    setModalsVisibility,
    openModal,
    closeModal,
    modalData,
    setModalData,
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }), [closeModal, modalsVisibility, openModal, setModalData]);

  return (
    <ModalContext.Provider value={value}>
      {children}
    </ModalContext.Provider>
  );
}

// Copyright © 2025 Micruity Inc.
